/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Bank200,
  GetApiV1Bank401,
  GetApiV1Bank500,
  GetApiV1BankQueryParams,
  GetApiV1BankQueryResponse,
} from "../../types/bankRegistroController/GetApiV1Bank.ts";
import { bankListItemViewModelPaginatedResponseSchema } from "../bankListItemViewModelPaginatedResponseSchema.ts";

export const getApiV1BankQueryParamsSchema = z.object({
  companyId: z.optional(z.coerce.number().int()),
  all: z.boolean().default(false),
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1BankQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Bank200Schema = z.lazy(
  () => bankListItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1Bank200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Bank401Schema =
  z.any() as unknown as ToZod<GetApiV1Bank401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Bank500Schema =
  z.any() as unknown as ToZod<GetApiV1Bank500>;

export const getApiV1BankQueryResponseSchema = z.lazy(
  () => getApiV1Bank200Schema,
) as unknown as ToZod<GetApiV1BankQueryResponse>;
